import React, { useCallback, useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { BsPencil } from "react-icons/bs";
import { IoTrashOutline } from "react-icons/io5";
import { MdAssignment } from "react-icons/md"
import { MdAssignmentReturned } from "react-icons/md"
import { MdAssignmentTurnedIn } from "react-icons/md"

import axios from 'axios'
import ModalEdit from '../ModalEdit';
import MemberFilter from './MemberFilter'
import ModalNewMembr from './ModalNewMembr';
import MoreOptions from './MoreOptions';
import MemberStatuse from './MemberStatuse';
import { HeaderTable } from '../HeaderTable';

const GET_URLDELETE = 'admin/member/delete_member'
const GET_URL = 'admin/member/get_members'
const GET_URLFORFILTER = 'admin/member/init_filter_member'
const URL_EXCLE = 'admin/member/getListFilterMembersNoPageNoSortingExcel'

const Member = () => {
    const [modalIsOpen, setModalIsOpen] = useState("");
    const [id, setId] = useState("");

    const [tableData, setTableData] = useState([]);
    const [filterOptions, setFilterOptions] = useState([]);

    const [isDownloading, setIsDownloading] = useState(false);

    const [loading, setloading] = useState(true)
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1)

    const [dataFillter, setDataFillter] = useState({
        "firstName": "",
        "lastName": "",
        "idNumber": "",
        "statusId": "",
        "pay_id": "",
        "pay_id_labal": "",
        "dateEn": "",
        "number": "",
        "dateSt": "",
    })

    const getTrainingDays = useCallback(async (page) => {
        setloading(true);
        try {
            const response = await axios.get(GET_URL, {
                params: {
                    ...dataFillter,
                    page: page,
                    size: perPage,
                },
            });
            if (response.status === 200) {
                setTableData(response?.data?.resMemberDisplayList);
                setTotalRows(response.data.totalElements);
            }
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setloading(false);
        }
    }, [dataFillter, perPage]);

    const getDataFILTER = async () => {

        await axios.get(GET_URLFORFILTER, {
        })
            .then(response => {
                setFilterOptions(response?.data)
            })

    }
const validateAndFetchLinks = async (dateStart, dateEnd) => {
    
  if (!dateStart || !dateEnd) {
    alert('נא לבחור תאריכים בטווח של שלושה חודשים');
    return;
  }
  console.log(dateStart, dateEnd)
  const start = new Date(dateStart);
  const end = new Date(dateEnd);

  if (end < start) {
    alert('טווח התאריכים לא תקין');
    return;
  }

  const yearDiff = end.getFullYear() - start.getFullYear();
  const monthDiff = end.getMonth() - start.getMonth() + (yearDiff * 12);

  if (monthDiff > 3) {
    alert('נא לבחור תאריכים בטווח של שלושה חודשים');
    return;
  }

  try {
     setIsDownloading(true)
    const response = await axios.get('admin/member/get_server_links', {
        params: {
                    
                    "dateStart": dateStart,
                    "dateEnd": dateEnd,
                },
    //   dateStart,
    //   dateEnd,
    });
console.log(response.data)
    const ids = response.data || []; // נניח שאתה מקבל מערך של ids בשם ids

    if (ids.length === 0) {
      alert('לא נמצאו קבצים להורדה בטווח התאריכים שנבחר');
      return;
    }

    for (const id of ids) {
    //   const url = `admin/member/build_profile_member/${id}`;
      await downloadimgCertificate(id);
    }
    // המשך הטיפול בתגובה (setState וכו')
  } catch (error) {
    console.error('שגיאה בשליפת קישורים:', error?.response?.data?.message);
    alert(error?.response?.data?.message||'אירעה שגיאה בשליפת הקישורים');
  } finally {
    setIsDownloading(false); // ✅ סיום – שחרור הכפתור
  }
};
    const handleDetele = async () => {

        await axios.delete(`${GET_URLDELETE}/${id.id}`).then(response => {
            if (response.status == 200) {
                handleColse()
                getTrainingDays()
                getDataFILTER()
                console.log("ok")
            }
            else {
                console.log("error")
            }
        })
    }



  const downloadimgCertificate = async (id) => {
        try {
          const response = await axios.get(`admin/member/build_profile_member/${id}`, {
           
            responseType: 'blob', // הגדרת התגובה כ-blob לצורך הורדת הקובץ
          });
      
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${id}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        } catch (error) {
          console.error('Error downloading file:', error);
        }
      
        }




    useEffect(() => {
        getTrainingDays(currentPage - 1)
    }, [currentPage, perPage, dataFillter])

    const handlePerRowsChange = async (newPerPage) => {
        setPerPage(newPerPage);

    }


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleColse = () => {
        setModalIsOpen("")
    }

    useEffect(() => {
        getDataFILTER()
    }, [])

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ensure 2 digits for month
        const day = ('0' + date.getDate()).slice(-2); // Ensure 2 digits for day
        return `${day}/${month}/${year}`;
    };
    const columns = [
        {
            name: "פעולות",

            cell: row => <div className='w-full'>
                {/* <a title="ייצא תעודה" className='p-0'
                    href={`https://archivebureau.s3.eu-west-3.amazonaws.com/${row.imgCertificate}`}> */}

                    <button onClick={()=>downloadimgCertificate(row?.id)} title="ייצא תעודה" className=' border border-gray-500 p-1 opacity-25 hover:opacity-100' ><MdAssignmentReturned /></button>
                    {/* </a> */}
                <button title="עוד אפשרויות" className=' border border-gray-500 ml-1 p-1 opacity-25 hover:opacity-100' onClick={() => {
                    setId(row)
                    setModalIsOpen("MoreOptions")
                }}><MdAssignment /></button>
                <button title="סטטוס חבר" className=' border border-gray-500 ml-1 p-1 opacity-25 hover:opacity-100' onClick={() => {
                    setId(row)
                    setModalIsOpen("Status")
                }}><MdAssignmentTurnedIn /></button>
                <button title="מחיקה" className=' border border-gray-500 ml-1 p-1 opacity-25 hover:opacity-100' onClick={() => {
                    setId(row)
                    setModalIsOpen("Delete")
                }}><IoTrashOutline /></button>
                <button className=' border border-gray-500 p-1  ml-1 opacity-25 hover:opacity-100' onClick={() => {
                    // setnamecalss(row?.description)
                    // setAction("edit")
                    setId(row)
                    setModalIsOpen("Edit")
                }
                }><BsPencil /></button>
            </div>,


            style: {
                fontSize: '10px',
                justifyContent: 'center',



                // padding: '2px'
                // width: '100%'
            },
            grow: 1,


        }, {
            name: "יתרה בארנק",
            grow: 2,
            selector: (row) => row?.balance+"₪",
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                width: '100px'
            },

        },
        {
            name: "לקוח משלם",
            grow: 2,
            selector: (row) => row.displayPaying,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                width: '100px'
            },

        },

        {
            name: "סטטוס",
            // grow: 3,
            selector: (row) => row?.status?.statusDescription,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },

        },
        {
            name: "תאריך הרשמה",
            grow: 1,
            selector: (row) => formatDate(row?.dateRegister),
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '500px'
            },

        },
        {
            name: "שם משפחה",
            // grow: 3,
            selector: (row) => row?.lastName,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },

        },
        {
            name: "שם פרטי",
            // grow: 3,
            selector: (row) => row?.firstName,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },

        },
        {
            name: "ת.ז",
            // grow: 3,
            selector: (row) => row?.idNumber,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },

        },


        {
            name: "מספר חבר",
            // grow: 3,
            selector: (row) => row?.number,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },



        },



    ];

    // useEffect(() => {
    //     setHide(modalIsOpen)
    // }, [modalIsOpen])

    const customStyles = {
        header: {
            style: {

                justifyContent: 'center',

            },
        },
        id: {
            style: {
                '&:2': { backgroundColor: '#EEEEEE' },
            }
        },
        headRow: {
            style: {
                justifyContent: 'center',
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                // borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {

                // whiteSpace: 'normal',
                // overflow: 'visible',
                // textOverflow: 'clip',
                // maxWidth: 'none', // Allow headers to expand as needed
                // padding: '10px'
                // ,
                fontSize: '10px',
                justifyContent: 'center',
                paddingLeft: '0px',
                paddingRight: '0px',
                borderRightStyle: 'solid',
                borderRightColor:'#333',
                borderRightWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor:'#333',
                borderBottomWidth: '1px',
                // borderRightColor: defaultThemes.default.divider.default,

            },
        },
        cells: {
            style: {
                '&:not(:last-of-type)': {
                    // padding: '10px'
                    // ,
                    //       paddingLeft:'0px',
                    // paddingRight:'0px',
                    //     borderRightStyle: 'solid',
                    //     borderRightWidth: '1px',
                    // borderRightColor: defaultThemes.default.divider.default,
                },
                borderRightStyle: 'solid',
                borderRightColor:'#333',
                borderRightWidth: '1px',
                paddingLeft: '0px',
                paddingRight: '0px',
                borderBottomStyle: 'solid',
                borderBottomColor:'#333',
                borderBottomWidth: '1px',
            },
        },
        rows: {
            style: {
                backgroundColor: '#FFFFFF',
                '&:active': {
                    backgroundColor: '#EEEEEE',
                },
            },
        },
    }

    const conditionalRowStyles = [
        {
          when: row => row?.status?.statusDescription =="פעיל", // תנאי - צביעת שורה עם score מעל 50
          style: {
            backgroundColor: '#dff0d8', // צבע רקע לשורה
                      // צבע הטקסט
            '&:hover': {
              cursor: 'pointer',       // אפקט hover
            },
          },
         
        },{
        when: row => row?.status?.statusDescription =="עזב"||row?.status?.statusDescription =="פנסיונר" ||row?.status?.statusDescription =="בהשלמת ימים", // תנאי - צביעת שורה עם score מעל 50
        style: {
          backgroundColor: '#fcf8e3', // צבע רקע לשורה
          color: 'black',             // צבע הטקסט
          '&:hover': {
            cursor: 'pointer',       // אפקט hover
          },
        }},
        // {when: row => row?.status?.statusDescription =="הסתיים", // תנאי - צביעת שורה עם score מעל 50
        // style: {
        //   backgroundColor: '#dff0d8', // צבע רקע לשורה
        //   color: 'black',             // צבע הטקסט
        //   '&:hover': {
        //     cursor: 'pointer',       // אפקט hover
        //   },
        // }},
        // {when: row => row?.status?.statusDescription =="בוטל", // תנאי - צביעת שורה עם score מעל 50
        // style: {
        //   backgroundColor: '#ffd3d3', // צבע רקע לשורה
        //   color: '#333',             // צבע הטקסט
        //   '&:hover': {
        //     cursor: 'pointer',       // אפקט hover
        //   },
        // }}
        // ,
        {when: row => row?.status?.statusDescription =="נפטר", // תנאי - צביעת שורה עם score מעל 50
        style: {
          backgroundColor: '#fcf8e3', // צבע רקע לשורה
          color: '#333',             // צבע הטקסט
          '&:hover': {
            cursor: 'pointer',       // אפקט hover
          },
        }}
        ,
        {when: row => row?.status?.statusDescription =="מושעה", // תנאי - צביעת שורה עם score מעל 50
        style: {
          backgroundColor: '#ffd3d3', // צבע רקע לשורה
          color: '#333',             // צבע הטקסט
          '&:hover': {
            cursor: 'pointer',       // אפקט hover
          },
        }}
        ,
        {when: row => row?.status?.statusDescription =="נפתח", // תנאי - צביעת שורה עם score מעל 50
        style: {
          backgroundColor: '#d9edf7', // צבע רקע לשורה
          color: '#333',             // צבע הטקסט
          '&:hover': {
            cursor: 'pointer',       // אפקט hover
          },
        }}
        
      ];

    const downloadExcel = async () => {
        try {
            const response = await axios.get(URL_EXCLE, {
                params: {
                    ...dataFillter
                    // member_number:"0001"
                },
                responseType: 'blob', // הגדרת התגובה כ-blob לצורך הורדת הקובץ
            });
            console.log(response?.data)
            const url = window.URL.createObjectURL(new Blob([response?.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'חברי הלשכה.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading file:', error);
        }

    }
    useEffect(() => {
        if (modalIsOpen) {
            document.body.style.overflow = 'hidden'; // Disable body scrolling
        } else {
            document.body.style.overflow = 'auto'; // Enable body scrolling
        }

        return () => {
            document.body.style.overflow = 'auto'; // Cleanup: ensure body scroll is reset
        };
        // setHide(modalIsOpen)
    }, [modalIsOpen])
    return (
        <div className='bg-[#f3f3f3] p-4 ' >
            <MemberFilter
                dataforFILTER={filterOptions}
                setDataFillterout={setDataFillter} />

            <HeaderTable active={"חברי הלשכה"} setModalIsOpen={setModalIsOpen} downloadExcel={downloadExcel} howmach={tableData?.length} >
        <button   className={`bg-[#1e8e2b] border border-[#1a7925] text-white w-fit h-fit flex justify-center items-center p-2 px-3 rounded-lg transition disabled:opacity-50`}
  disabled={isDownloading}
  onClick={() => validateAndFetchLinks(dataFillter?.dateSt, dataFillter?.dateEn)}
>
  {isDownloading ? (
    <div className="flex items-center gap-2">
      <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="white" strokeWidth="4" fill="none" />
        <path
          className="opacity-75"
          fill="white"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
      מוריד...
    </div>
  ) : (
    'הורדה'
  )}
       
       </button>

            </HeaderTable>

            {/* <h1>{tableData.length}</h1> */}


            <DataTable columns={columns} data={tableData} pagination customStyles={customStyles}
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={loading} className='border'
                conditionalRowStyles={conditionalRowStyles} >
                
            </DataTable>


            {modalIsOpen == "New" && <ModalNewMembr showModal={modalIsOpen == "New"} handleColse={handleColse} getDepartment={getTrainingDays}
                getDataFILTER={getDataFILTER}
            >
            </ModalNewMembr>}
            {modalIsOpen == "Edit" && <ModalNewMembr showModal={modalIsOpen == "Edit"} handleColse={handleColse} getDepartment={getTrainingDays} getDataFILTER={getDataFILTER} row={id}>
            </ModalNewMembr>}
            {modalIsOpen == "Delete" && <ModalEdit showModal={modalIsOpen == "Delete"} handleColse={handleColse} handleDetele={handleDetele}></ModalEdit>}
            {modalIsOpen == "MoreOptions" && <MoreOptions handleColse={handleColse} row={id}></MoreOptions>}
            {modalIsOpen == "Status" && (
                <MemberStatuse
                    showModal={modalIsOpen == "Status"}
                    handleColse={handleColse}
                    row={id}
                    onSaved={() => getTrainingDays(currentPage - 1)}
                ></MemberStatuse>
            )}

        </div>
    )
}

export default Member